const DownloadCardWeb = ({ platform, qrSrc, badgeHeight, platformText = "Tap or Scan to Download the App" }) => {
    const play_store = "./assets/img/google-play-badge-resized.png"
    const app_store = "./assets/img/app_store_092917.svg"
    return (
        <div className="card mb-3" style={{ border: '1px solid #0e0d0dff' }}>
            <div className="card-body d-flex align-items-center">
                <div className="me-3">
                    <img src={qrSrc} alt={`${platform} QR`} style={{ maxWidth: '80px', height: 'auto' }} />
                </div>
                <div className="flex-grow-1 text-start">
                    <h6 className="fw-bold mb-1">{platform}</h6>
                    <p className="mb-0 small text-muted">{platformText}</p>
                </div>
                <div className="ms-3">
                    <img
                        src={platform === "ANDROID" ? play_store : app_store}
                        alt={`${platform} Badge`}
                        style={{ height: badgeHeight, width: 'auto' }}
                    />
                </div>
            </div>
        </div>
    );
}

export default DownloadCardWeb;